export default "__VITE_ASSET__C4XgMHg5__"